export default "__VITE_ASSET__e13c5d89__"